import { tss } from '@ds/components'

export const useBreakpointStyles = tss.create(({ theme }) => ({
    showMobile: {
        display: 'none',
        [theme.breakpoints.down('lg')]: {
            display: 'block',
        },
    },
    showDesktop: {
        display: 'none',
        [theme.breakpoints.up('lg')]: {
            display: 'block',
        },
    },
}))
